import { Stack } from '@mui/material';
import { Button } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'src/components/common/link';
import { Routes } from 'src/components/common/router/constants';
import {
  Actions,
  AppArea,
  ResourcePageType,
  Subjects,
} from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const CreateResourceButton = () => {
  const { t } = useTranslation();

  return (
    <Can I={Actions.Write} a={Subjects.Resources} appArea={AppArea.Admin}>
      <Stack direction="row" spacing={2}>
        <Link
          to={Routes.adminResourcesCreate.path}
          queryParams={{ type: ResourcePageType.Document }}
        >
          <Button variant="contained" className="">
            {t('resources.list.create-document')}
          </Button>
        </Link>
        <Link
          to={Routes.adminResourcesCreate.path}
          queryParams={{ type: ResourcePageType.Download }}
        >
          <Button variant="contained" className="">
            {t('resources.list.create-download')}
          </Button>
        </Link>
        <Link
          to={Routes.adminResourcesCreate.path}
          queryParams={{ type: ResourcePageType.Video }}
        >
          <Button variant="contained" className="">
            {t('resources.list.create-video')}
          </Button>
        </Link>
      </Stack>
    </Can>
  );
};
